import React from "react";
import { Button } from "@/components/ui/button";

const Stat = ({ label, value, tone, testid }) => (
  <div className={`${tone} border-2 rounded-xl py-2`}>
    <div className="text-[10px] font-black uppercase opacity-80">{label}</div>
    <div className="font-display font-bold" data-testid={testid}>{value}</div>
  </div>
);

const FlyerResult = ({ biz, pack, stats, tomorrow, onDone }) => {
  const avgJob = Math.round((biz.priceRange[0] + biz.priceRange[1]) / 2);
  return (
    <div className="bg-white rounded-3xl border-4 border-emerald-300 p-6 text-center animate-pop-in" data-testid="flyer-game-result">
      <div className="text-6xl mb-2 animate-bounce-slow">📣</div>
      <h2 className="font-display text-2xl font-bold text-slate-900 mb-3">Marketing done!</h2>
      <div className="grid grid-cols-3 gap-2 mb-4">
        <Stat label="Spent" value={`-$${pack.price}`} tone="bg-rose-50 border-rose-200 text-rose-800" />
        <Stat label="Leads" value={stats.leads} tone="bg-emerald-50 border-emerald-200 text-emerald-800" testid="flyer-leads" />
        <Stat label="Wasted" value={stats.wasted + stats.penalties} tone="bg-slate-50 border-slate-200 text-slate-800" />
      </div>
      <p className="text-sm font-heading font-bold text-slate-700 mb-4" data-testid="flyer-result-msg">
        {tomorrow > 0
          ? `${tomorrow} new ${tomorrow === 1 ? "customer" : "customers"} will ask for your ${biz.name} help tomorrow (max 3/day). Each job earns about $${avgJob} — that's how marketing pays back!`
          : "No leads this time. Look for the 😀 neighbors, and skip 🚫 signs and busy people!"}
      </p>
      <Button onClick={onDone} data-testid="flyer-done-btn" className="bg-emerald-500 hover:bg-emerald-600 text-white font-heading font-black rounded-2xl btn-3d border-2 border-emerald-600 px-8 py-5">
        Back to customers →
      </Button>
    </div>
  );
};

export default FlyerResult;
